module.exports = __webpack_public_path__ + "static/media/moneybag.8b59b778.svg";